const routes = Object.values(
  import.meta.glob('@/steps/*/route.ts', { eager: true, import: 'default' }),
) as OwnbitConfigurator.Steps.Route[]

const saveDialog = {
  path: 'speichern',
  component: () => import('./DialogSpeichern.vue'),
}

const multiWarning = {
  path: 'warnung-mehrere',
  component: () => import('./DialogWarnungMehrere.vue'),
}

export type StepRoute = {
  meta: OwnbitConfigurator.Steps.Route['meta']
}

for (const route of routes) {
  route.children ??= []
  route.children.push(saveDialog, multiWarning)
}

export { routes }

export function isStepRoute(route: any): route is StepRoute {
  return route.meta?.step !== undefined && route.matched.length === 1
}

export const stepRoutes = routes.filter(route => 'step' in route.meta)
